import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import VendorHeader from "./../../component/VendorHeader";
import VendorFooter from "./../../component/VendorFooter";
import { API_BASE_URL, IMAGE_URL } from "../../utils/app_url";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import Sidebar from "../../component/Sidebar";
import DataTable from "react-data-table-component";


const deleteIcon = require("./../../assets/img/delete-icon.svg").default;

const AdminCategories = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { langJson } = useLanguage();
  const actionDivRef = useRef(null);

  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    total: 0,
    per_page: 20,
    last_page: 1,
  });

  const fetchCategories = async (page = 1) => {
    try {
      const response = await fetch(`${API_BASE_URL}products/admin/product-categories?page=${page}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        const list = responseData.data?.data || responseData.data;
        setCategoryList(Array.isArray(list) ? list : []);
        setPagination({
          total: responseData.data?.total || 0,
          per_page: responseData.data?.per_page || 20,
          last_page: responseData.data?.last_page || 1,
        });
        setCurrentPage(page);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm(langJson?.areyousure || "Are you sure you want to delete this category?")) {
      try {
        const response = await fetch(`${API_BASE_URL}products/admin/product-categories/${id}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          let tempArray = [...categoryList];
          let selIndex = tempArray.findIndex(item => parseInt(item?.id) === parseInt(id));
          tempArray.splice(selIndex, 1);
          setCategoryList(tempArray);
        }
      } catch (error) {
        console.error("Error deleting category:", error);
      }
    }
  };

  const columns = [
    {
      name: langJson?.image ?? "Image",
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {row?.image ? (
            <img
              src={IMAGE_URL + row.image}
              alt={row?.title}
              style={{
                width: 80,
                height: 80,
                objectFit: "cover",
                borderRadius: 4
              }}
            />
          ) : (
            <span>-</span>
          )}
        </div>
      ),
      width: "200px",
    },
    {
      name: langJson?.title,
      selector: (row) => row?.title,
      sortable: true,
    },
    {
      name: langJson?.action,
      cell: (row) => (
        <div className="actionDiv" ref={actionDivRef}>
          <button onClick={() => navigate(`/admin/categories/edit/${row?.id}`)}>
            {langJson?.edit ?? "Edit"}
          </button>
          <button onClick={() => handleDelete(row?.id)}>
            {langJson?.delete ?? "Delete"}
          </button>
        </div>
      ),
      width: "200px",
    },
  ];

  useEffect(() => {
    fetchCategories(currentPage);
  }, []);

  return (
    <div>
      <div className="dashHeader">
        <VendorHeader />
      </div>
      <div className="adminDash">
        <Sidebar />
        <div className="rightSide rightTop">
          <h2>{langJson?.categories ?? "Categories"}</h2>
          <div className="prdtTopRight">
            <Link to="/admin/categories/add">{langJson?.addnew ?? "Add New"}</Link>
          </div>
          <div className="prdtTable productListDataTable">
            <DataTable
              columns={columns}
              data={categoryList}
              pagination
              paginationServer
              paginationTotalRows={pagination.total}
              onChangePage={(page) => fetchCategories(page)}
              progressPending={loading}
              noDataComponent={<div style={{ padding: "20px" }}>{langJson?.nocategoriesfound ?? "No categories found"}</div>}
              striped
              highlightOnHover
              responsive
            />
          </div>
        </div>
      </div>
      <VendorFooter />
    </div>
  );
};

export default AdminCategories;
